<script lang="ts" setup>
const root = ref<HTMLDivElement>();

const scale_value = defineModel<number>("scale", { default: 1 });

const size = useElementSize(root);

const scale = computed(() => {
    if (scale_value.value !== 1) {
        const scale = 1 / scale_value.value;

        return `
            width: ${size.width.value * scale_value.value}px;
            height: ${size.height.value * scale_value.value}px;
            -moz-transform: scale(${scale}, ${scale});
            -webkit-transform: scale(${scale}, ${scale});
            -o-transform: scale(${scale}, ${scale});
            -ms-transform: scale(${scale}, ${scale});
            transform: scale(${scale}, ${scale});
            -moz-transform-origin: top left;
            -webkit-transform-origin: top left;
            -o-transform-origin: top left;
            -ms-transform-origin: top left;
            transform-origin: top left;
        `;
    }

    return `
            width: ${size.width.value}px;
            height: ${size.height.value}px;
    `;
});
</script>

<template>
    <div ref="root">
        <slot :style="scale" />
    </div>
</template>
